/**
 * Typed surface of the token layer.
 *
 * Components import semantic *names* from here, never colour values. That is
 * what allows both wireframe variants (dark `insightai-*.png`, light
 * `light-*.png`) to ship from one component tree.
 */
export { themes, primitives, contrastPairs, contrastExemptions, AI_RESERVED_TOKENS } from './themes.mjs'
export type { ThemeName, ThemeSetting, ContrastKind, ContrastPair } from './themes.mjs'
export { contrastRatio, relativeLuminance, simulateCvd, deltaE } from './color.mjs'

import { themes } from './themes.mjs'

/** Every semantic colour token name, for props that accept a token. */
export type ColorToken = keyof (typeof themes)['dark']

/** Status vocabulary shared by badges, pills, scorecards and KPI tiles. */
export const STATUS_TOKENS = {
  verified: {
    fg: 'state-verified',
    surface: 'state-verified-surface',
    border: 'state-verified-border',
  },
  warning: {
    fg: 'state-warning',
    surface: 'state-warning-surface',
    border: 'state-warning-border',
  },
  critical: {
    fg: 'state-critical',
    surface: 'state-critical-surface',
    border: 'state-critical-border',
  },
  info: { fg: 'state-info', surface: 'state-info-surface', border: 'state-info-border' },
} as const

export type StatusTone = keyof typeof STATUS_TOKENS

/** Attribute the ThemeProvider writes on <html>. */
export const THEME_ATTRIBUTE = 'data-theme'
